import { ImagePreview } from "@/components/preview/ImagePreview";

interface SvgPreviewProps {
	url: string;
	filename: string;
	/** 指定すると URL ではなくこの SVG を表示する。Source タブでの未保存編集内容の反映に使う。 */
	source?: string;
}

/**
 * SVG を img で描く。未保存の内容は data: URL にする。Blob URL はアプリのオリジンを持つため、
 * 画像を新しいタブで開かれると SVG 内のスクリプトがアプリのオリジンで動いてしまう。
 */
export function SvgPreview({ url, filename, source }: SvgPreviewProps) {
	const src =
		source === undefined ? url : `data:image/svg+xml;charset=utf-8,${encodeURIComponent(source)}`;
	return <ImagePreview url={src} filename={filename} />;
}
